import type { Comment } from '@/shared/types';

export interface ChatTurn {
  questions: Comment[];
  answers: Comment[];
  at: string;
}

function compareComments(a: Comment, b: Comment): number {
  const byTime = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
  if (byTime !== 0) return byTime;
  return String(a.id).localeCompare(String(b.id), undefined, { numeric: true });
}

/** Groups one consecutive user batch with all following AI replies. */
export function buildChatTurns(comments: Comment[]): ChatTurn[] {
  const asc = [...comments].sort(compareComments);
  const turns: ChatTurn[] = [];

  for (const comment of asc) {
    if (comment.author === 'ai') {
      const open = turns[turns.length - 1];
      if (open && open.questions.length > 0) {
        open.answers.push(comment);
      } else {
        turns.push({ questions: [], answers: [comment], at: comment.created_at });
      }
      continue;
    }

    const open = turns[turns.length - 1];
    if (open && open.answers.length === 0 && open.questions.length > 0) {
      open.questions.push(comment);
    } else {
      turns.push({ questions: [comment], answers: [], at: comment.created_at });
    }
  }

  return turns.reverse();
}
